<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Events from './events'

export default {
  page: {
    title: 'SharePoint Audit Events',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: { Layout, PageHeader, Events },
  data () {
    return {
      title: 'SharePoint Audit Events',
      category: 'List',
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'SharePoint Audit Events',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <div class="row">
      <div class="col-12">
        <b-alert
          show
          variant="info"
          class="d-flex align-items-center"
        >
          <feather
            type="info"
            class="icon-xs mr-2"
          />
          <span>
            This view only covers the <b>sensitive SharePoint sites predefined by the
              Corona Security Team</b>. Activity on any other site is not collected and
            will not appear here.
          </span>
        </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <Events :base-path="'/sharepoint/audit_events'" />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
